export default "__VITE_ASSET__BuhQqPvq__"